import { BackButton, ButtonWrapper } from './styled';
import ChevronLeftSolid from '@simplywallst/ui-core/icons/ChevronLeftSolid';
import { Text, useTheme } from '@simplywallst/ui-core';

interface Props {
  goBack: () => void;
  isNoteReminderExisting: boolean;
}

export const NoteReminderHeader = ({
  goBack,
  isNoteReminderExisting,
}: Props) => {
  const theme = useTheme();

  return (
    <ButtonWrapper
      gap={`${theme.x1spacePx}px`}
      alignItems="center"
      justifyContent="flex-start"
      templateColumns="auto auto"
    >
      <BackButton styleType="gentleReverse" onClick={goBack}>
        <ChevronLeftSolid />
        &nbsp;
        <Text typography="xSmall" color="chart01">
          {isNoteReminderExisting ? 'Update' : 'Add'} a reminder
        </Text>
      </BackButton>
    </ButtonWrapper>
  );
};
